import { TimelineEvent } from "../Timeline/Types";
import { getPlayer } from "../Timeline/Factory/GameTimelineFactory.service";
import { useIsFirstNameHidden } from "./useIsFirstNameHidden";
import { useCallback } from "react";

export const usePlayerInfo = () => {
    const hideFirstName = useIsFirstNameHidden();
    const getPlayerInfo = useCallback(
        (
            timelineEvent: TimelineEvent,
            type?: string,
        ): {
            id: string | undefined;
            imageUrl: string | undefined;
            name: string | undefined;
        } => {
            const player = getPlayer(timelineEvent, type);

            const name = hideFirstName
                ? player?.displayLastName
                : player?.displayFullName;

            return {
                id: player?.id,
                name,
                imageUrl: player?.imageUrl,
            };
        },
        [hideFirstName],
    );

    return { getPlayerInfo };
};
